
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum ProgressMessageStatus {
	None = 0,
	Processing = 1,
	Success = 2,
	Error = 3
}
export namespace ProgressMessageStatus {
	export function getKeys(): Map<ProgressMessageStatus, string> {
		return new Map([[0, 'None'], [1, 'Processing'], [2, 'Success'], [3, 'Error']]);
	}
}
